module.exports = __webpack_public_path__ + "img/magnifier.ea0b8173.svg";